import MapHandler from '../mapHandler';

export default class Segment extends MapHandler {
  constructor(options = {}) {
    super(options);
  }
}
